import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import style from "./CourseCategoryCards.module.css";
import Icon from "@/ui/icon/Icon";
import { useNavigate, useLocation } from "react-router-dom";
import { CATEGORY_VISUALS } from "@/features/courses/categoryVisuals";
import { useLocalized } from "@/i18n/useLocalized";

function CourseCategoryCards({
	categories,
	selectedCategory,
	setSelectedCategory,
}) {
	const navigate = useNavigate();
	const location = useLocation();

	const categoriesWithColors = useMemo(() => {
		return categories
			.filter((category) => category.slug in CATEGORY_VISUALS)
			.map((category) => {
				return {
					...category,
					...CATEGORY_VISUALS[category.slug],
				};
			});
	}, [categories]);

	const handleCategorySelect = (category) => {
		const newCategory =
			category.slug === selectedCategory ? null : category.slug;
		setSelectedCategory(newCategory);

		// Update URL with query parameter
		const searchParams = new URLSearchParams(location.search);
		if (newCategory) {
			searchParams.set("category", newCategory);
		} else {
			searchParams.delete("category");
		}
		navigate(`${location.pathname}?${searchParams.toString()}`);
	};

	return (
		<>
			{categoriesWithColors.map((category) => (
				<CategoryCard
					key={category.name}
					category={category}
					isSelected={selectedCategory === category.slug}
					onSelect={() => handleCategorySelect(category)}
				/>
			))}
		</>
	);
}

function CategoryCard({ category, isSelected, onSelect }) {
	const { t } = useTranslation();
	const l = useLocalized();
	const { color, icon, courseCount } = category;
	const isDisabled = courseCount === 0;

	return (
		<div
			className={`${style.card} ${isSelected ? style.active : ""} ${
				isDisabled ? style.disabled : ""
			}`}
			onClick={!isDisabled ? onSelect : null}
		>
			<div
				style={{ "--color": color }}
				className={style.background}
			></div>
			<div className={style.info}>
				<div className={style.name}>
					<div className={style.icoHolder}>
						<Icon icon={icon} />
					</div>
					<h3>{l(category, "name")}</h3>
				</div>
				<div className={style.count}>
					<span>{t("courses:categoryCards.courses")}</span>
					<span>{courseCount}</span>
				</div>
			</div>
		</div>
	);
}

export default CourseCategoryCards;
